import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

export const task: Task = {
  id: "758972d4-c601-4888-951b-9f49044232ed",
  solutionType: "text-or-number",
  type: "fillTheGap",
  options: {
    shuffle: true,
    type: "number",
    prefixText: "The <b>velocity</b> is",
    unit: "m/s",
  },
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "text-or-number",
  data: 500,
};
